/**
 * Returns the number of notifications to load, based on unreadNotificationsCount from authSettings.
 */

import useAuthSettings from '@apps/www/src/www/hooks/useAuthSettings';
import { useRef } from 'react';

const MIN_COUNT = 50;

export default function useNotificationsLimit(): number {
	const authSettings = useAuthSettings(['unreadNotificationsCount']);

	const unreadNotificationsCount = authSettings?.unreadNotificationsCount || 0;

	const unreadNotificationsCountRef = useRef(unreadNotificationsCount);

	// Only set if it increased. this prevents users with unread notifications greater than MIN_COUNT to have the
	// list flicker when opening the side notification panel.
	// It uses a ref to avoid re-renders from this hook.
	if (unreadNotificationsCount > unreadNotificationsCountRef.current) {
		unreadNotificationsCountRef.current = unreadNotificationsCount;
	}

	return Math.max(unreadNotificationsCountRef.current, MIN_COUNT);
}
